<template>
  <div class="card">
    <div class="bg-blue-light p-2">
      <TitleButton :showBtn="false" title="General Ledger" />

      <DateQuerySetter
          :inEnoughSpace="false"
          btnTitle="Go"
          @onClickGo="onClickGo"
      >
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label"
          >Select Account Head:
          </label>
          <v-select
              v-model="headId"
              :options="accountHeads"
              label="name"
              :reduce="(name) => name.id"
              placeholder="Select head"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">

            <div class="d-flex align-items-center justify-content-between filter-label">
                <label for="colFormLabel" class="col-form-label">Party: </label>
                <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                    <i class="fas fa-search"></i>
                </span>
            </div>

            <AsyncSelect
                placeholder="Select Party"
                v-model="contactProfile"
                :api-service="fetchContactProfiles"
                :format-label="formatPatientLabel"
            />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label
              for="colFormLabel"
              class="col-form-label"
          >Business</label
          >
          <v-select
              placeholder="Select Business"
              class="w-100"
              :options="businesses"
              label="name"
              :reduce="(name) => name.id"
              v-model="business_id"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="colFormLabel" class="col-form-label">Cost Center: </label>
            <v-select placeholder="Select Cost Centre" v-model="cost_centre_id" :options="costCentres"
                label="name" :reduce="name => name.id" />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="colFormLabel" class="col-form-label">Project</label>
            <v-select placeholder="Select Project" v-model="project_id" :options="projects" label="name"
                :reduce="name => name.id" />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label
              for="colFormLabel"
              class="col-form-label"
          >Voucher Type</label
          >
          <select class="form-control" v-model="voucher_type">
            <option :value="null" selected>Select voucher type</option>
            <option
                v-for="voucherType in Object.keys(homeData.voucher_type)"
                :value="voucherType" :key="voucherType"
            >
              {{ homeData.voucher_type[voucherType] }}
            </option>
          </select>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label
              for="colFormLabel"
              class="col-form-label"
          >txn Type</label
          >
          <select class="form-control" v-model="txn_type">
            <option :value="null" selected>Select txn type</option>
            <option :value="txnType" :key="txnType" v-for="txnType in typeKeys">
              {{ homeData.txn_type[txnType] }}
            </option>
          </select>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Created By: </label>
          <v-select placeholder="Created By" class="w-100" :options="contactList" label="name"
            :reduce="(name) => name.id" v-model="created_by" />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Tag Register</label>
          <v-select
              placeholder="Select Tag Register"
              class="w-100"
              :options="tagRegisters"
              label="name"
              :reduce="name => name.id"
              v-model="tag_register_id"
          />
        </div>
      </DateQuerySetter>
    </div>
    <div class="card mt-1">
      <div class="d-flex justify-content-between px-2">

        <div>

            <table class="head_left">

                  <tr>
                    <td>Account Name </td>
                    <td>
                      : <strong>{{ accounts.name }}</strong>
                    </td>
                  </tr>

                    <tr>
                        <td>Report period </td>
                        <td>
                          : <strong>{{ ledgerHeadData.report_period }}</strong>
                        </td>
                    </tr>

                  <tr>
                      <td>Party name </td>
                      <td>
                        : <strong>{{ ledgerHeadData.party_name }}</strong>
                      </td>
                  </tr>

                    <tr>
                        <td>Business </td>
                        <td>
                          : <strong>{{ ledgerHeadData.bussiness }}</strong>
                        </td>
                    </tr>

                  <tr>
                      <td>Cost Centre </td>
                      <td>
                        : <strong>{{ ledgerHeadData.cost_centre }}</strong>
                      </td>
                  </tr>

                  <tr>
                      <td>Project </td>
                      <td>
                        : <strong>{{ ledgerHeadData.project }}</strong>
                      </td>
                  </tr>
            </table>
        </div>

        <div>
          <table class="head">
            <tr>
              <td>Opening Balance :</td>
              <td>
                <strong>{{ commaFormat(ledgerData.opening_balance) }}</strong>
              </td>
            </tr>
            <tr>
              <td>Total Debit :</td>
              <td>
                <strong>{{ commaFormat(ledgerData.total_debit) }}</strong>
              </td>
            </tr>
            <tr>
              <td>Total Credit :</td>
              <td>
                <strong>{{ commaFormat(ledgerData.total_credit) }}</strong>
              </td>
            </tr>
            <tr>
              <td>Closing Balance :</td>
              <td>
                <strong>{{ commaFormat(ledgerData.closing_balance) }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="col-12 mt-2">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="goToPrint"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
          >
            Print
          </button>
          <button
              @click="exportTable"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
          >
            Export
          </button>
        </div>
      </div>
      <LedgerTable
          :openingBalance="ledgerData.opening_balance"
          :closingBalance="ledgerData.closing_balance"
          :totalDebitBalance="ledgerData.total_debit"
          :totalCreditBalance="ledgerData.total_credit"
          :currentPage="ledgerData?.ledgers?.current_page"
          :lastPage="ledgerData?.ledgers?.last_page"
          :ledgers="ledgers"
      />
    </div>
    <div class="px-2">
      <Pagination
          :offset="offset"
          @onPageChange="onPageChange"
          ref="pagination"
      />
      <ContactDropdownFilter
          v-if="store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          :isFilterable="true"
          :companyRoles="companyRoles"
      />
    </div>
    <Loader v-if="reportLoading" />
  </div>
</template>

<script>
import { mapMutations, useStore } from "vuex";
import handleReport from "@/services/modules/accountingReport";
import { inject } from "vue";

import TitleButton from "@/components/atom/TitleButton";
import Loader from "@/components/atom/LoaderComponent";
import DateQuerySetter from "@/components/atom/DateQuerySetter";
import LedgerTable from "@/components/molecule/company/ledger/LedgerTable";
import Pagination from "@/components/atom/Pagination";
import figureFormatter from "@/services/utils/figureFormatter";
import handleContact from "@/services/modules/contact";
import handleCBusinesses from "@/services/modules/businesses";
import handleJournal from '@/services/modules/journal'
import handleProjects from "@/services/modules/procurement/project";
import handleCostCentres from "@/services/modules/ngo/costCentre";
import handleImportTracker from "@/services/modules/procurement/importTracker";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleRole from "@/services/modules/role";
import handleTagRegister from "@/services/modules/scm/tag-register";
import pdfPrinter from '@/services/utils/pdf/generalLedger';
import handleCompany from "@/services/modules/company";

export default {
  name: "GeneralLedger",

  components: {
    TitleButton,
    DateQuerySetter,
    Pagination,
    LedgerTable,
    Loader,
    ContactDropdownFilter,
    AsyncSelect
  },

  data: () => ({
    tagRegisters: [],
    contactList: [],
    accountHeads: [],
    ledgerData: {
      opening_balance: '0.00',
      total_debit: '0.00',
      total_credit: '0.00',
      closing_balance: '0.00',
    },
    costCentres: [],
    projects: [],
    businesses: [],
    headId: null,
    homeData: {
      txn_type: {},
      voucher_type: {},
    },
    contactProfile: null,
    business_id: null,
    cost_centre_id: null,
    project_id: null,
    voucher_type: null,
    txn_type: null,
    created_by: null,
    tag_register_id: null,
    offset: 20,
    ledgerHeadData: {
      party_name: '',
      bussiness: '',
      cost_centre: '',
      project: '',
      report_period: '',
    },
    companyRoles: [],
    companyInfo: {}
  }),

  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
    start() {
      return this.$route.query.start;
    },
    end() {
      return this.$route.query.end;
    },
    page() {
      return this.$route.query.page;
    },
    ledgers() {
      return this.ledgerData.ledgers?.data ? this.ledgerData.ledgers.data : [];
    },
    accounts() {
      if (this.ledgerData.accounts) {
        return this.ledgerData.accounts;
      }

      if (this.accountHeads && this.accountHeads.length > 0 && this.headId) {
        return this.accountHeads.find(account => account.id === this.headId) ?? {}
      }

      return {};
    },
    token() {
      return localStorage.getItem("token");
    },
    typeKeys() {
      return Object.keys(this.homeData.txn_type);
    },
  },

  methods: {
    async getCompanyRoles () {
        const res = await this.fetchCompanyDefaultRoles(`?company_id=${this.$route.params.companyId}`);
        if (res.status) {
            this.companyRoles = res.data
        }
    },
    setLedgerHeadData() {
        this.ledgerHeadData.party_name = this.contactProfile ? this.contactProfile.name : ''
        this.ledgerHeadData.bussiness = this.ledgerData && this.ledgerData.length ? this.ledgerData[0].business_name : null;
        this.ledgerHeadData.cost_centre = this.ledgerData && this.ledgerData.length ? this.ledgerData[0].cost_centre_name : null;
        this.ledgerHeadData.project = this.ledgerData && this.ledgerData.length ? this.ledgerData[0].project_name : null;
        this.ledgerHeadData.report_period = this.start + ' to ' + this.end;
    },
    ...mapMutations({
      setPaginationData: "setPaginationData",
      resetPagination: "resetPagination",
    }),

    exportTable() {
      if (!this.headId) {
        this.showError("Please select head");
        return;
      }
      let query = this.getQuery();
      let url = `${process.env.VUE_APP_BASE_URL}/export/reports/general-ledger/${this.headId}${query}&_token=${this.token}`;
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.click();
    },

    async goToPrint() {
      let ledgerData = {};
      let query = this.getQuery();
      query += "&is_all=true";

      try {
        let res = await this.getLedger({
          headId: this.headId,
          query: query,
        });
        if (!res.status) {
          this.showError(res.message);
        }
        if (res.status) {
          ledgerData = res.data;
          ledgerData.accountName = this.accounts.name;
          ledgerData.business = this.ledgerHeadData.bussiness
          ledgerData.party_name = this.ledgerHeadData.party_name
          ledgerData.cost_centre = this.ledgerHeadData.cost_centre
          ledgerData.project = this.ledgerHeadData.project
          ledgerData.voucherType = this.voucher_type ? this.homeData.voucher_type[this.voucher_type] : null;
          ledgerData.txnType = this.txn_type ? this.homeData.txn_type[this.txn_type] : null;
          ledgerData.startDate = this.start;
          ledgerData.endDate = this.end;

          this.exportToPDF(this.companyInfo, ledgerData)
        }
      } catch (err) {
        if (!err.response) {
          this.showError("Something is wrong. Check your connectivity!!");
        }
        if (err.response?.data) {
          this.showError(err.response.data.message);
          return;
        }
      } finally {
        this.reportLoading = false;
      }
    },

    async getCompanyInfo() {
      try{
        let res = await this.fetchCompanyInfo(this.$route.params.companyId)
        if (!res.status) {
          this.showError(res.message);
          return;
        }
        this.companyInfo = res.data;
      } catch (err) {
        if (!err.response) {
          this.showError("Something is wrong. Check your connectivity!!");
        }
        if (err.response) {
          this.showError(err.response.message);
        }
      }
    },

    setPagination() {
      if (!this.ledgerData?.ledgers?.data) return;
      this.setPaginationData({
        records: this.ledgerData.ledgers.total,
        perPage: this.ledgerData.ledgers.per_page,
        currentPage: this.ledgerData.ledgers.current_page,
      });
    },
    onClickGo() {
      this.setPaginationData({});
      let routeQuery = Object.assign({}, this.$route.query);
      routeQuery.page = 1;
      this.$router.push({ path: this.$route.path, query: routeQuery });
      setTimeout(() => {
        this.getDateWiseLedger();
      }, 100);
    },

    onPageChange(page) {
      let routeQuery = Object.assign({}, this.$route.query);
      routeQuery.page = page;
      this.$router.push({ path: this.$route.path, query: routeQuery });
      setTimeout(() => {
        this.getDateWiseLedger();
      }, 100);
    },

    check() {
      this.$refs.pagination.setPage(2);
    },

    async getAccountHeads() {
      try {
        this.reportLoading = true;
        let accountHeadQuery = '?company_id=' + this.$route.params.companyId + '&status=active';
        let res = await this.fetchAccountHeadsList(accountHeadQuery);
        if (!res.status) {
          this.resetPagination();
          this.showError(res.message);
        }
        if (res.status) {
          this.accountHeads = res.data;
        }
      } catch (err) {
        if (!err.response) {
          this.showError("Something is wrong. Check your connectivity!!");
        }
        if (err.response) {
          this.showError(err.response.message);
        }
      } finally {
        this.reportLoading = false;
      }
    },

    async getHome() {
      try {
        let res = await this.fetchHome();
        if (!res.status) {
          //this.showError(res.message)
          this.resetPagination();
          this.homeData = {};
        }
        if (res.status) {
          this.homeData = res.data;
        }
      } catch (err) {
        if (err.response) {
          this.showError(err.response.message);
        }
      }
    },
    async getBusinesses() {
      try {
        let companyId = this.$route.params.companyId;
        let res = await this.fetchBusinessList("?company_id=" + companyId);

        if (res.status) {
          this.businesses = res.data;
        }
      } catch (err) {
        if (err.response) {
          this.showError(err.response.message);
        }
      } finally {
        this.loading = false;
      }
    },

    getQuery() {
      let query = "?company_id=" + this.companyId;
      if (!this.start && !this.end) return query;
      if (this.start) query += "&start_date=" + this.start;
      if (this.end) query += "&end_date=" + this.end;
      if (this.page) query += "&page=" + this.page;
      if (this.contactProfile) query += "&contact_profile_id=" + this.contactProfile.id;
      if (this.business_id) query += "&business_id=" + this.business_id;
      if (this.txn_type) query += "&txn_type=" + this.txn_type;
      if (this.voucher_type) query += "&voucher_type=" + this.voucher_type;
      if (this.cost_centre_id) query += "&cost_centre_id=" + this.cost_centre_id;
      if (this.project_id) query += "&project_id=" + this.project_id;
      if (this.created_by) query += "&created_by=" + this.created_by;
      if (this.tag_register_id) query += "&tag_register_id=" + this.tag_register_id;
      query += "&offset=" + this.offset;
      return query;
    },

    async getDateWiseLedger() {
      if (!this.headId) {
        this.showError("Please select head");
        return;
      }

      this.setLedgerHeadData();
      let query = this.getQuery();
      try {
        this.reportLoading = true;
        let res = await this.getLedger({
          headId: this.headId,
          query: query,
        });
        if (!res.status) {
          this.showError(res.message);
          this.ledgerData = {
            opening_balance: '0.00',
            total_debit: '0.00',
            total_credit: '0.00',
            closing_balance: '0.00',
          };
        }
        if (res.status) {
          this.ledgerData = res.data;
          this.setPagination();
          this.setLedgerHeadData();
        }
      } catch (err) {
        if (!err.response) {
          this.showError("Something is wrong. Check your connectivity!!");
        }
        if (err.response?.data) {
          this.showError(err.response.data.message);
        }
      } finally {
        this.reportLoading = false;
      }
    },

    onOpenContactSearchModal () {
        this.$store.state.isModalOpenThree = true;
    },

    onSearchContact (contact) {
        this.contactProfile = contact
    }
  },

  setup() {
    const showError = inject("showError");
    const showSuccess = inject("showSuccess");
    const store = useStore()
    const {
      fetchAccountHeadsList,
    } = handleJournal()
    const {
            fetchDaybook,
            reportLoading,
            fetchHome,
            getLedger,
          } = handleReport();

    const { commaFormat } = figureFormatter();

    const { fetchContactProfiles } = handleContact();
    const { formatPatientLabel } = useAsyncDropdownHelper();

    const { fetchBusinessList } = handleCBusinesses();
    const { fetchProjects } = handleProjects()
    const { fetchCostCentreList } = handleCostCentres();
    const { fetchContacts } = handleImportTracker();
    const { fetchCompanyDefaultRoles } = handleRole();
    const {fetchTagRegisterList} = handleTagRegister()
    const { exportToPDF } = pdfPrinter();
    const { fetchCompanyInfo } = handleCompany();

    return {
      // journals: computed(() => store.state.journal.journals),
      fetchContactProfiles,
      fetchBusinessList,
      fetchProjects,
      fetchCostCentreList,
      fetchTagRegisterList,
      fetchHome,
      fetchDaybook,
      reportLoading,
      fetchAccountHeadsList,
      showError,
      showSuccess,
      store,
      getLedger,
      commaFormat,
      fetchContacts,
      formatPatientLabel,
      fetchCompanyDefaultRoles,
      exportToPDF,
      fetchCompanyInfo
    };
  },

  mounted() {
    let companyId = this.$route.params.companyId
    let companyQuery = '?company_id=' + companyId;
    let projectQuery = companyQuery + '&with_donors=1';

    Promise.all([
      this.fetchContacts(companyQuery).then(res => {
        if (res.data) {
          this.contactList = res.data;
        }
      }),
      this.fetchProjects(projectQuery).then(res => {
        if (res.data) {
          this.projects = res.data
        }
      }),
      this.fetchCostCentreList(companyQuery).then(res => {
        if (res.data) {
          this.costCentres = res.data
        }
      }),
      this.fetchTagRegisterList(companyQuery).then(res => {
        if(res.data) {
          this.tagRegisters = res.data;
        }
      }),
      this.resetPagination(),
      this.getAccountHeads(),
      this.getHome(),
      this.getBusinesses(),
      this.getCompanyRoles(),
      this.getCompanyInfo(),
    ]).catch(err => {
      this.showError(err.message)
    })

    if (this.$route.query.headId) {
      this.headId = parseInt(this.$route.query.headId);
      this.onClickGo();
    }
  },
};
</script>

<style scoped>
.head td {
  text-align: right;
}

.head_left td{
  text-align: left;
}
</style>
